<template>
  <div class="kpi-grid">
    <slot>
      <KpiCard
        v-for="kpi in items"
        :key="kpi.id || kpi.label"
        :label="kpi.label"
        :value="kpi.value"
        :delta="kpi.delta"
        :icon="kpi.icon"
        :clickable="kpi.clickable"
        :loading="loading"
        @select="$emit('select', kpi.id || kpi.label)"
      />
    </slot>
  </div>
</template>

<script>
import KpiCard from "./KpiCard.vue";

export default {
  name: "KpiGrid",
  components: { KpiCard },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: { type: Boolean, default: false },
  },
  emits: ["select"],
};
</script>

<style scoped>
.kpi-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
}

@media (min-width: 600px) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 960px) {
  .kpi-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* At xl widths, promote to 4-across so 6 KPIs lay out as 4+2 rather than
   3+3 with empty space or 6-across with crushed values. */
@media (min-width: 1280px) {
  .kpi-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
